import { getDocs, collection } from 'firebase/firestore';
import { firestore } from '~/firebase/init';

import { MenuWithId, Menu } from '~/types/store/menu';

export default async function getMultiStoreMenus(
  storesId: Array<string>,
): Promise<Array<MenuWithId>> {
  const res = await Promise.all(
    storesId.map((storeId) => {
      const ref = collection(firestore, `stores`, storeId, 'menus');

      return getDocs(ref);
    }),
  );

  return res.flatMap((snap) => snap.docs).map((doc) => ({ id: doc.id, ...(doc.data() as Menu) }));
}
